import React, { FunctionComponent } from 'react';
import { Badge } from '../../Badge';

interface CanineScoreDescriptionProps {
  score: number | undefined;
}

// The severity is shown as a brand status badge (mint, banana, bubble gum, and the destructive color for severe).
const badgeClassName = 'px-3 py-1 text-md';

// CanineScoreDescription displays a description based on the score value.
export const CanineScoreDescription: FunctionComponent<CanineScoreDescriptionProps> = ({ score }) => {
  if (score === undefined) {
    return 'N/A';
  }

  if (score === 0) {
    return (
      <Badge variant="success" className={badgeClassName}>
        Normal
      </Badge>
    );
  }

  if (score == 1) {
    return (
      <Badge variant="warning" className={badgeClassName}>
        Mild
      </Badge>
    );
  }

  if (score == 2) {
    return (
      <Badge variant="danger" className={badgeClassName}>
        Moderate
      </Badge>
    );
  }

  return (
    <Badge variant="destructive" className={badgeClassName}>
      Severe
    </Badge>
  );
};
